// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_QEE","cls2":"ProfilePdfPackCard-cls2_XN_ ProfilePdfPackCard-cls1_QEE"};